import tmhRequest from '@/config/tmhRequest'

export default {
  searchListModule: function ( data) {
    return tmhRequest({
      url: '/system/tmh/module/searchlistmodule',
      method: 'post',
      params: data,
    })
  },

  addModule: function ( data) {
    return tmhRequest({
      url: '/system/tmh/module/addmodule',
      method: 'post',
      params: data,
    })
  },

  editModule: function ( data) {
    return tmhRequest({
      url: '/system/tmh/module/editmodule',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/system/module.js